/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
require("./src//shared/base.css");

exports.onInitialClientRender = () => {
  process.env.NODE_ENV === `development` && console.log("ReactDOM.render has executed");
};
